import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emailRegex } from '../../../helpers/regex/regex';
import Button from '../../base/button';
import { StyledErrorMessage } from '../../base/forms/formikFieldWrapper.styles';
import { Input } from '../../base/forms/input';
import { Label } from '../../base/forms/label';
import { H1, P } from '../../base/typography';

interface Props {
	landingPage: string;
	error: boolean;
	errorMessage: string;
	submit: (value: string) => void;
}

const LandingPagesVerifySocialId: FC<Props> = ({ landingPage, submit, error, errorMessage }) => {
	const { t } = useTranslation('myShipments');
	const [value, setValue] = useState('');
	const [validationError, setValidationError] = useState('');
	const header = t(`${landingPage}.header`);
	const paragraph = t(`${landingPage}.paragraph`);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const email = value.trim();

		if (!emailRegex.test(email)) {
			setValidationError(t('email-format'));
			return;
		}

		setValidationError('');
		submit(email);
	};

	return (
		<>
			<H1>{header}</H1>
			<P>{paragraph}</P>
			<Label>{t('email')}</Label>
			<form onSubmit={handleSubmit} noValidate>
				<Input
					type="email"
					placeholder={t('email')}
					value={value}
					onChange={e => {
						setValue(e.target.value);
						setValidationError('');
					}}
				/>
				{validationError ? <StyledErrorMessage>{validationError}</StyledErrorMessage> : null}
				{!validationError && error ? (
					<>
						<StyledErrorMessage>{t('status.Error')}</StyledErrorMessage>
						<StyledErrorMessage>{errorMessage}</StyledErrorMessage>
					</>
				) : null}
				<Button primary mobileBlock type="submit">
					{t('confirm')}
				</Button>
			</form>
		</>
	);
};

export default LandingPagesVerifySocialId;
